import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useSheet } from './useSheet';

export function Sheet({ title, subtitle, onClose, children, full = false, hideGrab = false, busy = false }: {
  title?: string; subtitle?: string; onClose: () => void; children: ReactNode; full?: boolean; hideGrab?: boolean; busy?: boolean;
}) {
  const { panel, requestDismiss } = useSheet(onClose, { busy });
  return createPortal(<div className="overlay sheet-layer" onClick={event => { if (event.target === event.currentTarget) requestDismiss('backdrop'); }}>
    <div className="sheet-motion" data-sheet-motion>
    <div ref={panel} className={`sheet sheet-interactive${full ? ' full' : ''}`} role="dialog" aria-modal="true" aria-label={title} aria-busy={busy} tabIndex={-1}>
      {!hideGrab && <button className="sheet-handle" data-sheet-handle type="button" aria-label="Закрыть шторку" disabled={busy} onClick={() => requestDismiss('handle')}><span aria-hidden="true" /></button>}
      <header data-sheet-header>{title && <h2>{title}</h2>}{subtitle && <p className="nt" style={{ margin: '2px 0 0' }}>{subtitle}</p>}</header>
      {children}
    </div>
    </div>
  </div>, document.body);
}

/** Confirmation dialogs remain centred; share accessibility, never swipe. */
export function Dialog({ title, children, confirmLabel, cancelLabel = 'Отмена', onConfirm, onCancel, danger = false, busy = false }: {
  title: string; children: ReactNode; confirmLabel: string; cancelLabel?: string; onConfirm: () => void; onCancel: () => void; danger?: boolean; busy?: boolean;
}) {
  const { panel, requestDismiss } = useSheet(onCancel, { busy, swipe: false });
  return createPortal(<div className="overlay center sheet-layer" onClick={event => { if (event.target === event.currentTarget) requestDismiss('backdrop'); }}>
    <div ref={panel} className="dialog" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1}>
      <h2>{title}</h2>{children}<div className="acts">
        <button className="b" type="button" onClick={() => requestDismiss('cancel')} disabled={busy}>{cancelLabel}</button>
        <button className={danger ? 'b d' : 'b p'} type="button" onClick={onConfirm} disabled={busy}>{confirmLabel}</button>
      </div>
    </div>
  </div>, document.body);
}
